class itemMenu {
  title: string;
  url?: string;
  childs?: any;
}

export const Pages: itemMenu[] = [
  { title: 'GPS Navigator', url: '/gps-navigator' },
  {
    title: 'Academic GPS',
    childs: [
      { title: 'Guidance', url: '/degree-progress' },
      { title: 'Planning', url: '/planning' },
      { title: 'Support', url: '/support' }
    ],
  },
  { title: 'Career GPS', url: '/employment' },
  { title: 'College Selection Request', url: '/enrollment-request' },
];

/* export const Pages: itemMenu[] = [
  {title: 'ACADEMIC CONSOLE', url: '/academic', icon: 'circle'},
  /* {title: 'CAREER CONSOLE', url: '/career', icon: 'circle'},
  {title: 'PROFESSIONAL CONSOLE', url: '/enrollment-request', icon: 'circle'},
  {title: 'EMPLOYMENT CONSOLE', url: '/employment', icon: 'circle'},
  {title: 'CHAT', url: '/chat', icon: 'circle'},
  {title: 'HELP', url: '/chat', icon: 'circle'},
  {title: 'SETTINGS', url: '/chat', icon: 'circle'}
]; */
